// ヴィノスやまざきの軌跡セクション
// 画像タップで拡大
function toggleImagePreview(imgElement) {
  var previewContainer = document.getElementById("image-preview");
  var previewImage = document.querySelector(".c-history__img-preview");
  var body = document.body;

  if (previewContainer.style.display === "flex") {
    // Hide the preview and enable scrolling
    previewContainer.style.display = "none";
    previewImage.src = ""; // Remove the src to avoid showing the wrong image next time
    body.style.overflow = ""; // Remove the style to re-enable scrolling
  } else {
    // Show the preview and disable scrolling
    previewContainer.style.display = "flex";
    previewImage.src = imgElement.src; // Set the src attribute to the image URL
    body.style.overflow = "hidden"; // Add the style to prevent scrolling
  }
}
